import NotificationManager from 'react-notifications/lib/NotificationManager';
import messageActionsTypes from '../actionTypes/messageActionTypes';

import {
  sendMessageApi,
  getChatsApi,
  uploadMessageImgApi,
  getChatPageApi,
  readMessageApi,
} from '../../api/apiUrls/message';
import getPhotosWithUrls from '../../helpers/getPhotosWithUrls';
import helpers from '../../helpers/helpers';

const sendMessageStart = () => ({
  type: messageActionsTypes.SEND_MESSAGE_START,
});

const sendMessageSuccess = (payload) => ({
  type: messageActionsTypes.SEND_MESSAGE_SUCCESS,
  payload,
});

const sendMessageFail = (error) => ({
  type: messageActionsTypes.SEND_MESSAGE_FAIL,
  error,
});

const sendMessageDiscard = () => ({
  type: messageActionsTypes.SEND_MESSAGE_STATUS_DISCARD,
});

const sendMessage = (message, token) => (dispatch) => {
  dispatch(sendMessageStart());

  return sendMessageApi(message, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(sendMessageSuccess({ ...response.data }));
        NotificationManager.success(response.data.data);
      }
    }).catch((error) => {
      dispatch(sendMessageFail(error));
    });
};

const addChatMessage = (chatId, message, setAsUnread = false) => ({
  type: messageActionsTypes.ADD_CHAT_MESSAGE,
  payload: {
    message,
    chatId,
    setAsUnread,
  },
});

const addNewChatMessages = (chatData) => (dispatch) => {
  if (chatData?.id && chatData?.messages?.data?.[0]) {
    dispatch(addChatMessage(chatData.id, chatData.messages.data[0], true));
  }
};

const sendChatMessage = (token, message, sender) => (dispatch) => (
  dispatch(sendMessage(message, token)).then(() => {
    const { name } = sender;
    const chatId = message.chat_id;
    const msg = {
      id: helpers.getRandomId(),
      sender,
      message: message.messages,
      photos: getPhotosWithUrls(message.photos, name, chatId),
      created: new Date(),
    };
    dispatch(addChatMessage(message.chat_id, msg));
  })
);

const getChatsStart = () => ({
  type: messageActionsTypes.GET_CHATS_START,
});

const getChatsSuccess = (payload) => ({
  type: messageActionsTypes.GET_CHATS_SUCCESS,
  payload,
});

const getChatsFail = () => ({
  type: messageActionsTypes.GET_CHATS_FAIL,
});

const getChats = (token) => (dispatch) => {
  dispatch(getChatsStart());

  return getChatsApi(token)
    .then((response) => {
      dispatch(getChatsSuccess(response));
    }).catch((error) => {
      dispatch(getChatsFail(error));
    });
};

const uploadImagesStart = () => ({
  type: messageActionsTypes.UPLOAD_IMAGES_START,
});

const uploadImagesSuccess = (payload) => ({
  type: messageActionsTypes.UPLOAD_IMAGES_SUCCESS,
  payload,
});

const uploadImagesFailure = () => ({
  type: messageActionsTypes.UPLOAD_IMAGES_FAIL,
});

const uploadImages = (token, images) => (dispatch) => {
  dispatch(uploadImagesStart());
  const promises = [];
  // eslint-disable-next-line array-callback-return
  Object.keys(images).map((imageKey) => {
    const formData = new FormData();
    formData.append('file', images[imageKey]);
    promises.push(uploadMessageImgApi(token, formData));
  });
  return Promise.all(promises).then((res) => {
    dispatch(uploadImagesSuccess());
    return res;
  }).catch(() => {
    dispatch(uploadImagesFailure());
  });
};

const getChatPageStart = () => ({
  type: messageActionsTypes.GET_CHAT_PAGE_START,
});

const getChatPageSuccess = (payload) => ({
  type: messageActionsTypes.GET_CHAT_PAGE_SUCCESS,
  payload,
});

const getChatPageFailure = () => ({
  type: messageActionsTypes.GET_CHAT_PAGE_FAIL,
});

const getChatPage = (token, params) => (dispatch) => {
  dispatch(getChatPageStart());
  return getChatPageApi(token, params)
    .then((res) => {
      dispatch(getChatPageSuccess({ data: res }));
      return res;
    })
    .catch(() => {
      dispatch(getChatPageFailure());
    });
};

const addChatPage = (payload) => ({
  type: messageActionsTypes.ADD_CHAT_PAGE,
  payload,
});

const getChatPageAndSave = (token, params, chatId) => (dispatch) => {
  dispatch(getChatPage(token, params))
    .then((res) => {
      dispatch(addChatPage({
        chatId,
        data: res,
      }));
    });
};

const readMessageSuccess = (chatId, messageId) => ({
  type: messageActionsTypes.READ_QUESTIONS_MESSAGE_SUCCESS,
  payload: {
    chatId,
    messageId,
  },
});

const readMessage = (token, chatId, messageId) => (dispatch) => (
  readMessageApi(token, chatId, messageId)
    .then((res) => {
      dispatch(readMessageSuccess(chatId, messageId));
      return res;
    })
    .catch((err) => err)
);

const messageActions = {
  sendMessage,
  sendMessageDiscard,
  sendChatMessage,
  getChats,
  uploadImages,
  getChatPage,
  getChatPageAndSave,
  addNewChatMessages,
  readMessage,
};

export default messageActions;
